<template>
  <div class="main-card">
    <div class="main-card__head">
      <div class="text-center">
        <MainCardCarSvg />
        <h1 v-html="$t('not_found.message')"></h1>
      </div>
    </div>
  </div>

</template>

<script>
  import MainCardCarSvg from '@images/MainCardCarSvg.vue';

  export default {
    components: {
      MainCardCarSvg
    }
  };
</script>
